var React = require('react');

function Tractor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Mobile Tractor Unit"),React.createElement("g",{"id":"g1643","key":2},[React.createElement("path",{"id":"path3512","className":"cls-1","d":"M14,34H44L54,44H74L84,34h30","key":0}),React.createElement("path",{"id":"path3512-9","className":"cls-1","d":"M14,94H44L54,84H74L84,94h30","key":1}),React.createElement("path",{"id":"path3471-4","className":"cls-1","d":"M94,74,84,64,94,54","key":2}),React.createElement("path",{"id":"path3471-4-9","className":"cls-1","d":"M34,74,44,64,34,54","key":3})])]);
}

Tractor.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Tractor;

Tractor.default = Tractor;
